import type { IChooseUseCaseFormValues } from "../ChooseUseCaseForm";

import { useMemo } from "react";

import { useSaveUserSegmentMutation } from "@/graphql/segment/segment.hooks";
import { GraphqlMappedError } from "@/services/graphqlErrorService";

interface IUseChooseUseCaseOptions {
  onCompleted?: () => void;
  onError?: (error: GraphqlMappedError) => void;
}

interface IUseChooseUseCaseReturnedValue {
  submit: (input: IChooseUseCaseFormValues) => Promise<void>;
  loading: boolean;
  error?: GraphqlMappedError;
}

function useChooseUseCase({
  onCompleted,
  onError,
}: IUseChooseUseCaseOptions = {}): IUseChooseUseCaseReturnedValue {
  const [submit, { loading, error }] = useSaveUserSegmentMutation({
    context: { errorType: "local" },
    onCompleted: () => onCompleted?.(),
    onError: (e) => onError?.(GraphqlMappedError.from(e)),
  });

  return useMemo(
    () => ({
      submit: async ({ category }: IChooseUseCaseFormValues) => {
        try {
          await submit({
            variables: {
              segment: category,
            },
          });
        } catch (e) {
          throw GraphqlMappedError.from(e);
        }
      },
      loading,
      error: error && GraphqlMappedError.from(error),
    }),
    [submit, loading, error]
  );
}

export default useChooseUseCase;
